import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { Navbar } from './components/common/Navbar';
import HomePage from './pages/HomePage';
import Estimate from './components/estimate/Estimate';
import Confirmation from './components/confirmation/Confirmation';
import BookingSuccess from './components/booking/BookingSuccess';
import PaymentPage from './pages/PaymentPage';
import ServicePage from './pages/ServicePage';
import AboutPage from './pages/AboutPage';
import DrivePage from './pages/DrivePage';
import SupportPage from './pages/SupportPage';
import BottomNav from './components/common/BottomNav';

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/estimate" element={<Estimate />} />
          <Route path="/confirm" element={<Confirmation />} />
          <Route path="/payment/:code" element={<PaymentPage />} />
          <Route path="/booking/:code" element={<BookingSuccess />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/drive" element={<DrivePage />} />
          <Route path="/support" element={<SupportPage />} />
        </Routes>
        <BottomNav />
        <ToastContainer
          position="top-right"
          autoClose={3500}
          newestOnTop
          closeOnClick
          pauseOnHover
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
